import { z } from "zod";

import { LocationMapSchema } from "@widgets/contact-map-card";

import { ColorIconSchema } from "@shared/content-types/schemas/common.schema";
import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";
import { RichTextSchema } from "@shared/content-types/schemas/richText.schema";

export const MerchVariantSchema = z.object({
  id: z.number().int().positive(),
  images: z.array(StrapiMediaSchema),
  price: z.number().int().positive(),
  sizes: z.string().min(1),
  color: z.object({
    name: z.string().min(1),
    value: z.string().min(1),
  }),
});

export const MerchSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime().optional(),
  title: z.string().min(1),
  uid: z.string().min(1),
  link: z.string().min(1),
  description: z.string().min(1),
  price: z.number().int().positive(),
  icon: ColorIconSchema,
  mainImage: StrapiMediaSchema,
  merchVariations: z.array(MerchVariantSchema),
  detailInfo: RichTextSchema,
  recomendation: RichTextSchema,
  composition: RichTextSchema,
  contactMapSection: LocationMapSchema,
  isViewSizeTable: z.boolean(),
});
